import { DEFAULT_COMPONENT_SET_ID, getComponentSetDefinition } from '../component-sets/registry.js';
import { getDefaultThemeModeId } from '../theme_modes.js';
import {
  DEFAULT_THEME_PACK_ID,
  DEFAULT_THEME_REF,
  getThemeDefinition,
  getThemePackDefinition,
  isThemeLifecycleSelectable
} from '../theme-packs/registry.js';

export function resolveActiveComponentSetId(requestedSetId = DEFAULT_COMPONENT_SET_ID) {
  const definition = getComponentSetDefinition(requestedSetId);
  return definition ? definition.setId : DEFAULT_COMPONENT_SET_ID;
}

export function resolveThemeRef(themeRef = {}, options = {}) {
  const componentSetId = resolveActiveComponentSetId(options.componentSetId);
  const requestedPackId = String(themeRef.packId || DEFAULT_THEME_PACK_ID).trim().toLowerCase() || DEFAULT_THEME_PACK_ID;
  const requestedThemeId = String(themeRef.themeId || getDefaultThemeModeId()).trim().toLowerCase() || getDefaultThemeModeId();

  let pack = getThemePackDefinition(requestedPackId);
  if (!pack || !Array.isArray(pack.compatibleSets) || !pack.compatibleSets.includes(componentSetId)) {
    pack = getThemePackDefinition(DEFAULT_THEME_PACK_ID);
  }

  const requestedTheme = pack && Array.isArray(pack.themes)
    ? (pack.themes.find((theme) => theme.themeId === requestedThemeId) || null)
    : null;
  if (requestedTheme && isThemeLifecycleSelectable(requestedTheme)) {
    return {
      componentSetId,
      themeRef: Object.freeze({ packId: pack.packId, themeId: requestedTheme.themeId }),
      themeDef: requestedTheme,
      clamped: false,
      warning: ''
    };
  }

  const fallbackPack = getThemePackDefinition(DEFAULT_THEME_PACK_ID);
  const fallbackTheme = fallbackPack ? getThemeDefinition(DEFAULT_THEME_REF.themeId, fallbackPack.packId) : null;
  const warning = `UI theme '${requestedPackId}/${requestedThemeId}' is unavailable. Clamped to '${DEFAULT_THEME_REF.packId}/${DEFAULT_THEME_REF.themeId}'.`;

  return {
    componentSetId,
    themeRef: Object.freeze({ packId: DEFAULT_THEME_PACK_ID, themeId: DEFAULT_THEME_REF.themeId }),
    themeDef: fallbackTheme,
    clamped: true,
    warning
  };
}

export function resolvePersistedThemeSelection(options = {}) {
  const persisted = options.persisted && typeof options.persisted === 'object'
    ? options.persisted
    : {};
  const resolution = resolveThemeRef({
    packId: DEFAULT_THEME_PACK_ID,
    themeId: persisted && persisted.themeId
  }, options);

  return {
    persisted,
    ...resolution
  };
}
